import React from 'react';  
import ColorBends from './ColorBends';

export default function NebulaBackground() {
  return (
    <div className="fixed inset-0 -z-10">
      <ColorBends
        speed={0.6} // kecepatan animasi
        colors={["#5b21b6", "#3b82f6", "#9333ea", "#1e3a8a"]} // gradasi ungu kebiruan
        amplitude={0.4} // intensitas lengkungan warna
        blur={80} // lembutkan transisi
        opacity={0.8} // transparansi
      />
    </div>
  );
}
